import React, { useState, useEffect } from "react";

import { endPoints } from "../../../constant/Environment";
import { getAllData, getAllFilterData } from "../../../Utility/API";
import { Box, Button, IconButton, TablePagination, Typography } from "@mui/material";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import moment from "moment-timezone";
import { useTheme } from "@mui/material/styles";

import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
import { tokens } from "../../../theme";
import { mono, pill, statusKind, th, td, ConfirmDialog } from "./uiKit";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
    </Box>
  );
}

const differentEmailRowBg = "rgba(245,166,35,0.10)";

const CashDetails = (props) => {
  const { selectedRecord } = props;
  const [editData, setEditData] = useState({});

  const [cancleShow, setCancleShow] = useState(false);
  const [checkShow, setCheckShow] = useState(false);
  const [pauseShow, setPauseShow] = useState(false);
  const [viewShow, setViewShow] = useState(false);
  const [regenShow, setRegenShow] = useState(false);

  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  useEffect(() => {
    paymentsData(selectedRecord.id_user);
  }, [selectedRecord]);

  const paymentsData = async (userId) => {
    let url = `${endPoints.api.GIFT_CASH_TRANSACTION}${userId}/${1}/${1000}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response?.status === "success") {
          setRows(response.data);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const updateTransaction = async (alldata, status, closeDialog) => {
    try {
      let url = `${endPoints.api.TRANSACTION_UPDATE}`;
      let data = {
        id_transaction: alldata.id_transaction,
        id_user: alldata.id_user,
        status: status,
      };
      setIsLoading(true);
      let response = await getAllFilterData(url, data);
      setIsLoading(false);
      if (response?.status == "success") {
        SuccesToast(response.message);
        paymentsData(selectedRecord.id_user);
        closeDialog();
      } else {
        ErrorToast(response?.message);
      }
    } catch (Err) {
      console.log(Err);
    } finally {
      setIsLoading(false);
    }
  };

  const Approval = (alldata) => updateTransaction(alldata, 1, () => setCheckShow(false));
  const Cancel = (alldata) => updateTransaction(alldata, 3, () => setCancleShow(false));
  const Hold = (alldata) => updateTransaction(alldata, 2, () => setPauseShow(false));

  const Regenerate = async (alldata) => {
    try {
      let url = `${endPoints.api.TRANSACTION_REGENERATE}`;
      let data = {
        id_transaction: alldata.id_transaction,
        id_user: alldata.id_user,
        status: alldata.status ?? 0,
      };
      setIsLoading(true);
      let response = await getAllFilterData(url, data);
      setIsLoading(false);
      if (response?.status == "success") {
        SuccesToast(response.message);
        paymentsData(selectedRecord.id_user);
        setRegenShow(false);
      } else {
        ErrorToast(response?.message);
      }
    } catch (Err) {
      console.log(Err);
    } finally {
      setIsLoading(false);
    }
  };

  const txFacts = (d) => [
    ["Customer ID", d?.id_user],
    ["Transaction ID", d?.id_transaction],
    ["Customer Name", d?.name],
    ["Transaction Date", d?.insertion_time ? moment.utc(d.insertion_time).format("YYYY-MM-DD") : "—"],
    ["User Name", d?.login],
    ["Amount", d?.tamount != null ? `$${d.tamount}` : "—"],
  ];

  return (
    <Box>
      <Toaster></Toaster>
      {isLoading && <Loader spinner={true} visible={isLoading} />}

      <Typography variant="h6" sx={{ mb: 0.5 }}>
        Withdrawal Requests
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 2 }}>
        Cash withdrawal transactions for this player · rows tinted when payout email differs from account email
      </Typography>

      <Box sx={{ overflowX: "auto" }}>
        <Box component="table" sx={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={th}>Player</th>
              <th style={th}>Email</th>
              <th style={th}>Transaction</th>
              <th style={th}>Trans Date</th>
              <th style={th}>Processed</th>
              <th style={th}>Amount</th>
              <th style={th}>Status</th>
              <th style={th}>Decision</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && !isLoading && (
              <tr>
                <td colSpan={8} style={{ ...td, textAlign: "center", color: tokens.textDim }}>
                  No withdrawal requests found
                </td>
              </tr>
            )}
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                <tr key={row.id} style={{ background: row.isDifferentEmail ? differentEmailRowBg : "transparent" }}>
                  <td style={td}>
                    <div style={{ fontWeight: 600 }}>
                      {row.name} {row.surname}
                    </div>
                    <div style={{ fontFamily: mono, fontSize: 10.5, color: tokens.textDim2 }}>
                      #{row.id_user} · {row.login}
                    </div>
                  </td>
                  <td style={td}>
                    <div style={{ fontFamily: mono, fontSize: 11.5 }}>{row.email}</div>
                    {row.isDifferentEmail ? pill("different", "warn") : pill("same", "ok")}
                  </td>
                  <td style={td}>
                    <div style={{ fontFamily: mono }}>{row.id_transaction}</div>
                    <div style={{ fontSize: 10.5, color: tokens.textDim2 }}>{row.type == 24 ? "Corepay" : "Skrill"}</div>
                  </td>
                  <td style={{ ...td, fontFamily: mono, color: tokens.textDim }}>
                    {moment.utc(row.insertion_time).format("YYYY-MM-DD")}
                  </td>
                  <td style={{ ...td, fontFamily: mono, color: tokens.textDim }}>
                    {row.status == 1 ? moment.utc(row.updated_on).format("YYYY-MM-DD") : ""}
                  </td>
                  <td style={{ ...td, fontFamily: mono, fontWeight: 700 }}>${row.tamount}</td>
                  <td style={td}>
                    {row.transaction_status ? pill(row.transaction_status, statusKind(row.transaction_status)) : ""}
                  </td>
                  <td style={td}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Button
                        size="small"
                        variant="outlined"
                        color="inherit"
                        sx={{ textTransform: "none", color: tokens.textDim, borderColor: tokens.border }}
                        onClick={() => {
                          setViewShow(true);
                          setEditData(row);
                        }}
                      >
                        View
                      </Button>
                      {row.status == 1 || row.status == 3 ? null : (
                        <>
                          <Button
                            size="small"
                            variant="outlined"
                            sx={{ textTransform: "none", color: tokens.secondary, borderColor: "rgba(35,214,160,0.4)" }}
                            onClick={() => {
                              setCheckShow(true);
                              setEditData(row);
                            }}
                          >
                            Approve
                          </Button>
                          <Button
                            size="small"
                            variant="outlined"
                            sx={{ textTransform: "none", color: tokens.secondary, borderColor: "rgba(35,214,160,0.4)" }}
                            onClick={() => {
                              setRegenShow(true);
                              setEditData(row);
                            }}
                          >
                            Regenerate
                          </Button>
                          <Button
                            size="small"
                            variant="outlined"
                            disabled={row.status == 2}
                            sx={{ textTransform: "none", color: tokens.amber, borderColor: "rgba(245,166,35,0.4)" }}
                            onClick={() => {
                              setPauseShow(true);
                              setEditData(row);
                            }}
                          >
                            Hold
                          </Button>
                          <Button
                            size="small"
                            variant="outlined"
                            sx={{ textTransform: "none", color: tokens.danger, borderColor: "rgba(242,92,102,0.4)" }}
                            onClick={() => {
                              setCancleShow(true);
                              setEditData(row);
                            }}
                          >
                            Cancel
                          </Button>
                        </>
                      )}
                    </Box>
                  </td>
                </tr>
              ))}
          </tbody>
        </Box>
      </Box>

      <TablePagination
        component="div"
        className="hide-rows-per-page-options"
        rowsPerPageOptions={[5, 10, 25, 50]}
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        SelectProps={{
          inputProps: { "aria-label": "rows per page" },
          native: true,
        }}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        ActionsComponent={TablePaginationActions}
        sx={{ borderTop: `1px solid ${tokens.border}`, mt: 1 }}
      />

      <ConfirmDialog
        open={viewShow}
        onClose={() => setViewShow(false)}
        title="Withdrawal Details"
        facts={[
          ...txFacts(editData),
          ["Withdrawal Status", editData?.transaction_status],
          ["Transaction Type", editData?.type == 24 ? "Corepay" : "Skrill"],
        ]}
      />

      <ConfirmDialog
        open={checkShow}
        onClose={() => setCheckShow(false)}
        title="Withdrawal Approval"
        facts={txFacts(editData)}
        question="Would you like to approve this transaction?"
        note="After approval, funds will be sent to the payment provider."
        actionLabel="Approve Withdrawal"
        actionColor={tokens.secondary}
        onAction={() => Approval(editData)}
      />

      <ConfirmDialog
        open={regenShow}
        onClose={() => setRegenShow(false)}
        title="Withdrawal Regeneration"
        facts={txFacts(editData)}
        question="Would you like to regenerate this withdrawal?"
        note="A new payment order ID will be generated and sent to the payment provider."
        actionLabel="Regenerate Withdrawal"
        actionColor={tokens.secondary}
        onAction={() => Regenerate(editData)}
      />

      <ConfirmDialog
        open={pauseShow}
        onClose={() => setPauseShow(false)}
        title="Place Withdrawal On Hold"
        facts={txFacts(editData)}
        question="Would you like to put this transaction on hold?"
        note="This transaction will be held while you investigate. You can return later to approve or cancel."
        actionLabel="Put on Hold"
        actionColor={tokens.amber}
        onAction={() => Hold(editData)}
      />

      <ConfirmDialog
        open={cancleShow}
        onClose={() => setCancleShow(false)}
        title="Withdrawal Cancellation"
        facts={txFacts(editData)}
        question="Would you like to cancel this transaction?"
        note="After cancellation funds will be returned to the player’s account."
        actionLabel="Cancel Withdrawal"
        actionColor={tokens.danger}
        onAction={() => Cancel(editData)}
      />
    </Box>
  );
};

export default CashDetails;
